<template>
  <v-app-bar
    :height="height"
    :style="$vuetify.breakpoint.lgAndUp ? 'padding-left: 8.3333333333%; padding-right: 8.3333333333%;' : ''"
    app
    class="elevation-0"
    clipped-right
    color="brand-beige-dark"
  >
    <div
      v-if="logo"
      class="d-flex align-center fill-height"
    >
      <router-link
        :to="{name: 'Home'}"
        style="line-height: 0"
      >
        <img
          :alt="$t('Common.App.Title')"
          :src="LogoDarkSvg"
          height="24"
        >
      </router-link>
    </div>

    <div class="flex-grow-1" />

    <template v-if="account">
      <template v-if="userIsAuthenticated">
        <v-menu
          v-model="accountMenu"
          class="elevation-0 VANGER"
          max-width="400"
          offset-y
        >
          <template #activator="{on, attrs}">
            <v-btn
              :class="{'brand-beige': $vuetify.breakpoint.smAndDown}"
              :disabled="isAuthLoading"
              :loading="isAuthLoading"
              class="brand-green-dark--text"
              color="brand-green-dark"
              depressed
              icon
              large
              v-bind="attrs"
              v-on="on"
            >
              <span
                v-if="$vuetify.breakpoint.smAndDown"
                class="font-weight-bold brand-text-small-title"
              >
                {{ toLocaleUpperCase(userInitials) }}
              </span>

              <v-icon v-else>
                mdi-account
              </v-icon>
            </v-btn>
          </template>

          <v-card color="brand-card-bg">
            <v-list
              class="px-2"
              color="transparent"
            >
              <v-list-item :to="{name: 'Account'}">
                <v-avatar
                  class="rounded mr-4 brand-text-title"
                  color="brand-primary"
                  size="42"
                  tile
                >
                  {{ userInitials }}
                </v-avatar>

                <v-list-item-content>
                  <v-list-item-title class="brand-text-title brand-green-dark--text">
                    {{ user.Info.Firstname }} {{ user.Info.Lastname }}
                  </v-list-item-title>

                  <v-list-item-subtitle class="brand-text-small brand-grey--text">
                    {{ $t('Auth.AccountDialog.MemberSince') }} {{ user.Info.DateAdded }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon>
                    mdi-chevron-right
                  </v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider />

            <v-card-actions>
              <v-spacer />

              <v-btn
                :disabled="isAuthLoading"
                :loading="isAuthLoading"
                class="text-none brand-text-title"
                color="brand-primary"
                depressed
                @click="logout"
              >
                {{ toLocaleUpperCase($t('Auth.Button.Logout')) }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </template>

      <template v-else>
        <v-btn
          :class="{'brand-beige': $vuetify.breakpoint.smAndDown}"
          :icon="$vuetify.breakpoint.smAndDown"
          :text="!$vuetify.breakpoint.smAndDown"
          class="brand-green-dark--text text-capitalize ml-1 px-2"
          color="brand-green-dark"
          dark
          depressed
          large
          @click="onLoginClick"
        >
          <v-icon v-if="$vuetify.breakpoint.smAndDown">
            mdi-account
          </v-icon>

          <template v-else>
            <span class="text-body">{{ $t('Auth.Button.Login') }} / {{ $t('Auth.Button.Register') }}</span>
          </template>
        </v-btn>
      </template>
    </template>


    <v-btn
      v-if="!AppConfig?.Marketplace?.MaintenanceMode"
      :class="{'brand-beige': $vuetify.breakpoint.smAndDown}"
      class="brand-green-dark--text ml-1"
      color="brand-green-dark"
      dark
      depressed
      icon
      large
      @click.stop="navigationDrawerVisible = !navigationDrawerVisible"
    >
      <v-badge
        :value="cartProductsCount > 0"
        bordered
        color="brand-beige-light"
        overlap
      >
        <template #badge>
          <span class="brand-green-dark--text">{{ cartProductsCount }}</span>
        </template>

        <v-icon>
          mdi-cart
        </v-icon>
      </v-badge>
    </v-btn>

    <lang-switch
      v-if="langSwitch"
      class="ml-1"
    />

    <template
      v-if="AppConfig.Toolbar.AppToolbarExtended"
      #extension
    >
      <slot name="extension-prepend" />
      <slot name="extension">
        <portal-target
          name="AppToolbarExtension"
          slim
        />
      </slot>
      <slot name="extension-append" />
    </template>
  </v-app-bar>
</template>

<script>
import AppToolbarMixin from '@/theme/default/components/app/AppToolbar.js'

export default {
  name  : 'AppToolbar',
  mixins: [AppToolbarMixin],

  props: {
    height: {
      type   : [String, Number],
      default: 65
    }
  }
}
</script>

<style scoped src="@/theme/default/components/app/AppToolbar.css"></style>

<style scoped>
.v-menu__content {
  box-shadow: unset !important;
}
</style>
